import {
  FIELDTYPE_BODYINFORMATION,
  FIELDTYPE_CONCLUSION,
  FIELDTYPE_ESDH_TITLE,
  FIELDTYPE_TITLE,
} from '../../../../constants/api';

export const getPanelFieldTemplateHeader = (
  translator,
  fieldTypeEnum,
  isEditing,
) => {
  if (isEditing) {
    switch (fieldTypeEnum) {
      case FIELDTYPE_TITLE:
        return translator('pages.adminFieldTemplates.panelEditTitleHeader');
      case FIELDTYPE_BODYINFORMATION:
        return translator('pages.adminFieldTemplates.panelEditBodyTextHeader');
      case FIELDTYPE_CONCLUSION:
        return translator(
          'pages.adminFieldTemplates.panelEditConclusionTextHeader',
        );
      case FIELDTYPE_ESDH_TITLE:
        return translator('pages.adminFieldTemplates.panelEditESDHTitleHeader');
      default:
        return translator('pages.adminFieldTemplates.unknownField');
    }
  } else {
    switch (fieldTypeEnum) {
      case FIELDTYPE_TITLE:
        return translator('pages.adminFieldTemplates.panelCreateTitleHeader');
      case FIELDTYPE_BODYINFORMATION:
        return translator(
          'pages.adminFieldTemplates.panelCreateBodyTextHeader',
        );
      case FIELDTYPE_CONCLUSION:
        return translator(
          'pages.adminFieldTemplates.panelCreateConclusionTextHeader',
        );
      case FIELDTYPE_ESDH_TITLE:
        return translator(
          'pages.adminFieldTemplates.panelCreateESDHTitleHeader',
        );
      default:
        return translator('pages.adminFieldTemplates.unknownField');
    }
  }
};

export const getColumnHeader = (translator, fieldTypeEnum) => {
  switch (fieldTypeEnum) {
    case FIELDTYPE_TITLE:
      return translator('pages.adminFieldTemplates.Title');
    case FIELDTYPE_BODYINFORMATION:
      return translator('pages.adminFieldTemplates.BodyText');
    case FIELDTYPE_CONCLUSION:
      return translator('pages.adminFieldTemplates.Conclusion');
    case FIELDTYPE_ESDH_TITLE:
      return translator('pages.adminFieldTemplates.ESDHTitle');
    default:
      return translator('pages.adminFieldTemplates.unknownField');
  }
};
